export const marquee = () => {
  if (window.innerWidth >= 991) return;

  const marqueeContent = document.querySelector(".topbar__list");
  if (!marqueeContent) return;

  const marqueeItems = marqueeContent.innerHTML;
  for (let i = 0; i < 3; i++) {
    marqueeContent.innerHTML += marqueeItems;
  }

  let startX = 0;
  let scrollX = 0;
  let isDragging = false;
  let currentTranslate = 0;
  let lastTouchX = 0;

  const setTransform = (x) => {
    marqueeContent.style.transform = `translateX(${x}px)`;
  };

  marqueeContent.addEventListener("touchstart", (e) => {
    isDragging = true;
    startX = e.touches[0].clientX;
    lastTouchX = startX;
    marqueeContent.style.transition = "none";
  });

  marqueeContent.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    const deltaX = e.touches[0].clientX - startX;
    currentTranslate = scrollX + deltaX;
    setTransform(currentTranslate);
    lastTouchX = e.touches[0].clientX;
  });

  marqueeContent.addEventListener("touchend", () => {
    isDragging = false;
    scrollX = currentTranslate;
    marqueeContent.style.transition = "transform 0.3s ease-out";
  });

  let lastTimestamp = null;
  const speed = 0.5;

  const step = (timestamp) => {
    if (!lastTimestamp) lastTimestamp = timestamp;
    const delta = timestamp - lastTimestamp;
    lastTimestamp = timestamp;

    if (!isDragging) {
      scrollX -= speed;
      currentTranslate = scrollX;
      setTransform(currentTranslate);
    }

    const resetThreshold = marqueeContent.scrollWidth / 2;
    if (Math.abs(scrollX) > resetThreshold) {
      scrollX = 0;
      currentTranslate = 0;
      setTransform(0);
    }

    requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};
